import React, { useState, useEffect, useRef } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';
import './Layout.css';

export default function Layout({ children }) {
  const { usuario, logout, atualizarTema } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [config, setConfig] = useState(() => {
    try { return JSON.parse(localStorage.getItem('empresa_config') || '{}'); } catch { return {}; }
  });
  const [avatarUsuario, setAvatarUsuario] = useState(null);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [modalPerfil, setModalPerfil] = useState(false);
  const [formPerfil, setFormPerfil] = useState({ nome: '', senha: '', confirmarSenha: '' });
  const [salvandoPerfil, setSalvandoPerfil] = useState(false);
  const avatarRef = useRef(null);

  useEffect(() => {
    api.get('/config').then(({ data }) => {
      setConfig(data);
      localStorage.setItem('empresa_config', JSON.stringify(data));
    }).catch(() => {});
    if (usuario?.id) {
      api.get('/usuarios/me/perfil').then(({ data }) => {
        if (data?.avatar_url) setAvatarUsuario(data.avatar_url);
      }).catch(() => {});
    }
    const onUpdate = () => {
      try { setConfig(JSON.parse(localStorage.getItem('empresa_config') || '{}')); } catch {}
    };
    window.addEventListener('empresa_config_updated', onUpdate);
    return () => window.removeEventListener('empresa_config_updated', onUpdate);
  }, [usuario]);

  const ativo = (p) => location.pathname.startsWith(p) ? 'nav-item ativo' : 'nav-item';

  const abrirPerfil = () => {
    setFormPerfil({ nome: usuario?.nome || '', senha: '', confirmarSenha: '' });
    setModalPerfil(true);
  };

  const salvarPerfil = async () => {
    if (formPerfil.senha && formPerfil.senha !== formPerfil.confirmarSenha) {
      toast.error('As senhas não coincidem');
      return;
    }
    setSalvandoPerfil(true);
    try {
      const payload = { nome: formPerfil.nome };
      if (formPerfil.senha) payload.senha = formPerfil.senha;
      await api.put('/usuarios/me', payload);
      toast.success('Perfil atualizado!');
      setModalPerfil(false);
    } catch(err) { toast.error(err.response?.data?.erro || 'Erro ao salvar'); }
    finally { setSalvandoPerfil(false); }
  };

  const uploadAvatarPerfil = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const form = new FormData();
    form.append('avatar', file);
    try {
      const { data } = await api.post('/usuarios/me/avatar', form);
      setAvatarUsuario(data.avatar_url);
      toast.success('Foto atualizada!');
    } catch { toast.error('Erro ao enviar foto'); }
  };

  return (
    <div className="layout-root">
      <aside className={`layout-sidebar${sidebarCollapsed ? ' collapsed' : ''}`}>
        <button onClick={() => setSidebarCollapsed(s => !s)}
          style={{position:'absolute',top:8,right:-12,width:24,height:24,borderRadius:'50%',background:'var(--bg-sidebar-hover)',border:'1px solid var(--border)',color:'var(--text-sidebar)',cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,zIndex:10}}>
          {sidebarCollapsed ? '›' : '‹'}
        </button>
        <div className="layout-logo">
          {config.empresa_logo_url
            ? <img src={config.empresa_logo_url} alt="Logo" onError={e => e.target.style.display='none'} />
            : <div className="logo-icon">💬</div>
          }
          <div>
            <div className="logo-nome">{config.empresa_nome || 'Atendimento'}</div>
            <div className="logo-sub">WhatsApp</div>
          </div>
        </div>

        <nav className="layout-nav">
          <div className="nav-section-label">Atendimento</div>
          <button className={ativo('/atendimento')} onClick={() => navigate('/atendimento')}>
            <span className="nav-icon">🎧</span><span className="nav-label"> Fila de Atendimento</span>
          </button>
          {(usuario?.perfil === 'admin' || (usuario?.canaisAdmin && usuario.canaisAdmin.length > 0)) && (<>
            <div className="nav-section-label" style={{ marginTop: 12 }}>Administração</div>
            <button className={ativo('/admin/canais')} onClick={() => navigate('/admin/canais')}>
              <span className="nav-icon">📱</span><span className="nav-label"> Canais WhatsApp</span>
            </button>
            <button className={ativo('/admin/usuarios')} onClick={() => navigate('/admin/usuarios')}>
              <span className="nav-icon">👥</span><span className="nav-label"> Usuários</span>
            </button>
            {usuario?.perfil === 'admin' && (
              <button className={ativo('/admin/configuracoes')} onClick={() => navigate('/admin/configuracoes')}>
                <span className="nav-icon">⚙️</span><span className="nav-label"> Configurações</span>
              </button>
            )}
            <button className={ativo('/admin/relatorios')} onClick={() => navigate('/admin/relatorios')}>
              <span className="nav-icon">📊</span><span className="nav-label"> Relatórios</span>
            </button>
            <button className={ativo('/admin/clientes')} onClick={() => navigate('/admin/clientes')}>
              <span className="nav-icon">👥</span><span className="nav-label"> Clientes</span>
            </button>
          </>)}
        </nav>

        <div className="layout-user">
          {avatarUsuario
            ? <img src={avatarUsuario} alt={usuario?.nome}
                style={{ width:30, height:30, borderRadius:'50%', objectFit:'cover', flexShrink:0 }}
                onError={e => e.target.style.display='none'} />
            : <div className="luser-avatar">{usuario?.nome?.slice(0,2).toUpperCase()}</div>
          }
          <div className="luser-info">
            <div className="luser-nome">{usuario?.nome}</div>
            <div className={`luser-perfil ${usuario?.perfil}`}>{usuario?.perfil}</div>
          </div>
          <button className="btn-sair" onClick={abrirPerfil} title="Meu perfil" style={{marginRight:4}}>👤</button>
          <button className="btn-sair" onClick={logout} title="Sair" style={{fontSize:11,padding:'4px 8px',borderRadius:'var(--radius-sm)'}}>Sair</button>
        </div>
      </aside>

      <main className="layout-main">{children}</main>
      {modalPerfil && (
        <div className="modal-overlay" onClick={() => setModalPerfil(false)}>
          <div className="modal-box" onClick={e => e.stopPropagation()} style={{width:380}}>
            <div className="modal-header">
              <h3>Meu Perfil</h3>
              <button onClick={() => setModalPerfil(false)}>✕</button>
            </div>
            <div style={{padding:'16px 20px',display:'flex',flexDirection:'column',gap:14}}>
              <div style={{display:'flex',flexDirection:'column',alignItems:'center',gap:8}}>
                {avatarUsuario
                  ? <img src={avatarUsuario} alt="avatar" style={{width:72,height:72,borderRadius:'50%',objectFit:'cover',border:'2px solid var(--orange)'}} />
                  : <div style={{width:72,height:72,borderRadius:'50%',background:'var(--orange)',display:'flex',alignItems:'center',justifyContent:'center',fontSize:24,color:'white',fontWeight:700}}>{usuario?.nome?.slice(0,2).toUpperCase()}</div>
                }
                <button className="btn-secondary" style={{fontSize:12}} onClick={() => avatarRef.current?.click()}>📷 Alterar foto</button>
                <input ref={avatarRef} type="file" accept="image/*" style={{display:'none'}} onChange={uploadAvatarPerfil} />
              </div>
              <div className="form-group">
                <label>Nome completo</label>
                <input type="text" value={formPerfil.nome} onChange={e => setFormPerfil(p => ({...p, nome: e.target.value}))} />
              </div>
              <div className="form-group">
                <label>Nova senha</label>
                <input type="password" value={formPerfil.senha} onChange={e => setFormPerfil(p => ({...p, senha: e.target.value}))} placeholder="Deixe em branco para não alterar" />
              </div>
              <div className="form-group">
                <label>Confirmar nova senha</label>
                <input type="password" value={formPerfil.confirmarSenha} onChange={e => setFormPerfil(p => ({...p, confirmarSenha: e.target.value}))} placeholder="Repita a nova senha" />
              </div>
              <div className="form-group">
                <label>Cor do tema</label>
                <div style={{display:'flex',gap:10,marginTop:4,alignItems:'center',flexWrap:'wrap'}}>
                  {[
                    { id: 'azul', cor: '#137aba' },
                    { id: 'verde', cor: '#0d9268' },
                    { id: 'roxo', cor: '#7c3aed' },
                    { id: 'laranja', cor: '#ea580c' },
                    { id: 'vermelho', cor: '#dc2626' },
                  ].map(t => (
                    <button key={t.id} title={t.id} onClick={() => atualizarTema(t.id)}
                      style={{
                        width:32, height:32, borderRadius:'50%', background:t.cor, cursor:'pointer',
                        border: (usuario?.tema || 'azul') === t.id ? '2px solid white' : '2px solid transparent',
                        boxShadow: (usuario?.tema || 'azul') === t.id ? `0 0 0 2px ${t.cor}` : 'none',
                        flexShrink:0,
                      }} />
                  ))}
                  <div style={{display:'flex',alignItems:'center',gap:6,marginLeft:4}}>
                    <input type="color"
                      id="cor-personalizada"
                      defaultValue="#137aba"
                      style={{width:32,height:32,borderRadius:'50%',border:'2px dashed var(--border)',cursor:'pointer',padding:2,background:'transparent'}} />
                    <button
                      onClick={() => { const v = document.getElementById('cor-personalizada').value; atualizarTema(v); }}
                      style={{fontSize:12,padding:'3px 8px',borderRadius:6,background:'var(--tema-cor)',color:'white',border:'none',cursor:'pointer'}}>
                      Aplicar
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn-secondary" onClick={() => setModalPerfil(false)}>Cancelar</button>
              <button className="btn-primary" onClick={salvarPerfil} disabled={salvandoPerfil}>
                {salvandoPerfil ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
